const targetNode = document.getElementById("ReturngoPortalEmbedding");
const loader = document.querySelector('.page_loader');

if (targetNode && loader) {
    const config = { attributes: false, childList: true, subtree: false };
    loader.hidden = false;

    const callback = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                loader.hidden = true;
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}
